import './FilterProps.css';
import React, {useEffect, useState} from 'react';
import FilterPrice from '../filterPrice/FilterPrice';
import FilterProp from '../filterProp/FilterProp';

function FilterProps(props) {

  return (
      <>
        {
          props.items.map(filter => {
            return filter.PRICE ?
                <FilterPrice {...filter}
                             isMobile={props.isMobile}
                             key={'price'}
                             messages={props.messages}
                             onChange={props.onPriceChange}/> :
                <FilterProp {...filter}
                            key={filter.XML_ID}
                            messages={props.messages}
                            onChange={props.onChange}/>;
          })
        }
      </>
  );
};

export default FilterProps;